import axiosInstance from '../axiosInterceptor/axiosInstance'

const startLivestream = async (broadcastId, orgId) => {
  const url = `v1/orgs/${orgId}/streams/${broadcastId}/start`
  return axiosInstance.post(url, {})
}

export default startLivestream
